import { flatten, sortBy, range } from 'lodash';

export const MONTHS_ID_TO_LETTER = {
	1: 'J',
	2: 'F',
	3: 'M',
	4: 'A',
	5: 'M',
	6: 'J',
	7: 'J',
	8: 'A',
	9: 'S',
	10: 'O',
	11: 'N',
	12: 'D',
};

export const MONTHS_LETTER_TO_WORD = {
	1: 'January',
	2: 'February',
	3: 'March',
	4: 'April',
	5: 'May',
	6: 'June',
	7: 'July',
	8: 'August',
	9: 'September',
	10: 'October',
	11: 'November',
	12: 'December',
};

const months = range(1, 13);

export const createTimeline = data => {
	if (!data || !data.length) {
		return [];
	}

	const dataPeriods = data.map(companyData =>
		companyData.spendOverTime.map(({ year, month }) => ({ year, month }))
	);
	const sortedPeriods = sortBy(flatten(dataPeriods), ['year', 'month']);
	const minDate = sortedPeriods[0];
	const maxDate = sortedPeriods[sortedPeriods.length - 1];
	const minMonth = minDate.month;
	const maxMonth = maxDate.month;

	const years = range(minDate.year, maxDate.year + 1);
	if (years.length === 1) {
		return range(minMonth, maxMonth + 1).map(month => ({
			month,
			year: years[0],
		}));
	}
	return years.reduce((acc, year) => {
		if (year === years[0]) {
			range(minDate.month, 13).forEach(month => acc.push({ month, year }));
		} else if (year === years[years.length - 1]) {
			range(1, maxDate.month + 1).forEach(month => acc.push({ month, year }));
		} else {
			months.forEach(month => acc.push({ month, year }));
		}
		return acc;
	}, []);
};

export const createCategories = timeline => {
	const categoriesAmount = timeline.length;
	return timeline.map(({ month, year }) => {
		if (categoriesAmount >= 120) {
			return year;
		}
		return `${MONTHS_ID_TO_LETTER[month]}|${year}`;
	});
};

export const getTickInterval = ticksAmount => {
	if (ticksAmount <= 20) {
		return 1;
	} else if (ticksAmount <= 40) {
		return 2;
	} else if (ticksAmount <= 60) {
		return 3;
	} else if (ticksAmount <= 80) {
		return 4;
	} else if (ticksAmount <= 120) {
		return 6;
	}
	return 12;
};
